/**
 * wallpapers — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const wallpapersPack: ToilePack = {
    slug: 'wallpapers',
    category: 'wallpaper',
    name: 'Wallpapers',
    tagline: tagline('wallpapers', 'scenes', 'formats'),
    chips: chips('scenes', 'formats'),
    ratio: SQUARE,
    readings: [
        {key: 'forest', label: 'Misty forest', subject: 'a misty pine forest at dawn, a single hawk'},
        {key: 'neon', label: 'Neon city', subject: 'a rain-soaked neon city street at night'},
        {key: 'dunes', label: 'Desert dunes', subject: 'minimal desert dunes under a gradient sky'},
    ],
    styles: [
        {key: 'phone', label: 'Phone', style: 'phone lock-screen, vertical', palette: 'atmospheric, restrained color', framing: 'vertical, 768×1344', ratio: {w: 768, h: 1344}},
        {key: 'desktop', label: 'Desktop', style: 'ultrawide desktop panorama', palette: 'atmospheric, restrained color', framing: 'panoramic, 1792×768', ratio: {w: 1792, h: 768}},
        {key: 'tablet', label: 'Tablet', style: 'square tablet wallpaper', palette: 'atmospheric, restrained color', framing: 'square, 1024×1024', ratio: {w: 1024, h: 1024}},
    ],
    directions: ['a stormy sea instead', 'in deep blue and violet', 'darker, for night use'],
}
